import { Block, HowToReg, MoreHoriz, Print } from "@mui/icons-material";
import { Box, CircularProgress, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { fetchArray } from "entity";
import Inscricao from "entity/Inscricao";
import Reuniao from "entity/Reuniao";
import React, { useState } from "react";
import DialogStatus from "../../DialogStatus";
import useNotification from "notification";
import EtiquetaInscricaoReport from "entity/Inscricao/Relatorios/EtiquetaInscricaoReport";
import ReunioesParticipanteReport from "entity/Inscricao/Relatorios/ReunioesParticipanteReport";
import firebaseUtil from "firebaseUtil";
import { writeBatch } from "firebase/firestore";

export default function AcoesIncricao({ inscricao, rodada, inscricoes, reunioes }) {
    const { showError } = useNotification();
    const [loadingAction, setLoadingAction] = useState(false);
    const [anchorElPrint, setAnchorElPrint] = useState(null);
    const [anchorElOptions, setAnchorElOptions] = useState(null);
    const [anchorElStatus, setAnchorElStatus] = useState(null);
    const [openAusente, setOpenAusente] = useState(false);
    const [openSaiu, setOpenSaiu] = useState(false);
    // const [openCancelado, setOpenCancelado] = useState(false)

    const saveReunioes = async (values) => {
        let entity = new Reuniao();
        entity.update(values);
        entity
            .save()
            .then(() => {
                // console.log("Reunião salva com Sucesso");
            })
            .catch((e) => {
                console.error(e.message);
            });
    };

    const saveListReunioes = async (reunioes) => {
        const db = firebaseUtil.db;
        // Inicie o batch
        const batch = writeBatch(db);

        reunioes.forEach((REU) => {
            // Supondo que 'inscricao.id' seja o ID do documento no Firestore
            // const inscricaoRef = doc(db, "inscricoes", inscricao.id);
            let entity = new Reuniao();
            entity.update(REU);
            const ref = entity.doc;

            // Adicione a operação de atualização ao batch
            batch.update(ref, REU);
        });

        try {
            // Execute o batch para aplicar todas as alterações
            await batch.commit();
            console.log("Reuniões atualizadas com sucesso!");
        } catch (error) {
            console.error("Erro ao atualizar Reuniões: ", error);
        }
    };

    const queryReunioes = async (statusEventoFilter) => {
        return new Promise((resolve, reject) => {
            setLoadingAction(true);
            let entity = new Inscricao();
            entity.update({ uid: inscricao.uid, statusEvento: statusEventoFilter });

            Reuniao.query().then((query) => {
                query = query.where("status", "==", "ATIVO");
                query = query.where("rodada.uid", "==", inscricao.rodada.uid);
                fetchArray(query.get()).then((result) => {
                    result = result.filter(
                        (r) => r.inscricao1.uid === inscricao.uid || r.inscricao2.uid === inscricao.uid
                    );
                    let updateReunioes = [];
                    if (statusEventoFilter === "SAIU" || statusEventoFilter === "AUSENTE") {
                        result.forEach((r) => {
                            r.status = "INATIVO";
                            // saveReunioes(r);
                            updateReunioes.push(r);
                        });
                    } else if (statusEventoFilter === "PRESENTE" || statusEventoFilter === "INSCRITO") {
                        result.forEach((r) => {
                            if (r.inscricao1.uid === inscricao.uid) {
                                r.inscricao1.statusEvento = statusEventoFilter;
                            } else {
                                r.inscricao2.statusEvento = statusEventoFilter;
                            }
                            // saveReunioes(r);
                            updateReunioes.push(r);
                        });
                    }

                    saveListReunioes(updateReunioes);
                });
            });

            entity
                .save()
                .then(() => {
                    console.log("Salvou a inscrição");
                    resolve();
                })
                .catch((error) => {
                    console.error("Erro ao salvar inscrição:", error);
                })
                .finally(() => {
                    console.log("Finalizando operação");
                    setLoadingAction(false);
                });
        });
    };

    const saiuOnClick = async () => {
        queryReunioes("SAIU");
    };

    const ausenteOnClick = async () => {
        setAnchorElStatus(false);
        setAnchorElOptions(false);
        queryReunioes("AUSENTE");
    };

    const presenteOnClick = async () => {
        queryReunioes("PRESENTE");
    };

    const inscritoOnClick = async () => {
        setAnchorElStatus(false);
        setAnchorElOptions(false);
        queryReunioes("INSCRITO");
    };

    const imprimirCracha = (participante) => {
        console.log("imprimirCrachá", participante);
        new EtiquetaInscricaoReport(participante).generate({ onlyPrint: true });
    };

    const imprimirAgenda = (participante) => {
        console.log('participante', participante)
        console.log('reunioes', reunioes)
        let reunioesP = reunioes
            .filter((r) => r.inscricao1.uid === participante.uid)
            .concat(reunioes.filter((r) => r.inscricao2.uid === participante.uid));

        new ReunioesParticipanteReport({ participante, reunioes: reunioesP }).generate({
            textoCabecalho1: participante.rodada.nome, // "textoCabecalho1",
            textoCabecalho2: participante.rodada.descricao, // "textoCabecalho2",
        });
    };
    if (loadingAction) {
        return (
            <Box sx={{ display: "flex", width: "100%", minWidth: 95, justifyContent: "end" }}>
                <CircularProgress />
            </Box>
        );
    }
    return (
        <Box sx={{ display: "flex", width: "100%", minWidth: 95, justifyContent: "end" }}>
            {inscricao.statusEvento !== "PRESENTE" ? (
                <Tooltip title="PRESENTE">
                    <IconButton onClick={presenteOnClick}>
                        <HowToReg />
                    </IconButton>
                </Tooltip>
            ) : (
                <Tooltip title="SAIU">
                    <IconButton onClick={() => setOpenSaiu(true)}>
                        <Block />
                    </IconButton>
                </Tooltip>
            )}

            <IconButton
                aria-controls="print-menu"
                aria-haspopup="true"
                onClick={(event) => setAnchorElPrint(event.currentTarget)}
                color="inherit"
            >
                <Print />
            </IconButton>
            <Menu
                id="print-menu"
                anchorEl={anchorElPrint}
                open={Boolean(anchorElPrint)}
                onClose={() => setAnchorElPrint(null)}
            >
                <MenuItem
                    onClick={() => {
                        if (inscricao.termo && inscricao.status !== "PENDENTE/INSCRICAO") {
                            imprimirCracha(inscricao);
                        } else {
                            showError("Inscrição Pendente");
                        }
                    }}
                >
                    Crachá
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        if (inscricao.termo && inscricao.status !== "PENDENTE/INSCRICAO") {
                            imprimirAgenda(inscricao);
                        } else {
                            showError("Inscrição Pendente");
                        }
                    }}
                >
                    Agenda
                </MenuItem>
            </Menu>

            <IconButton
                aria-controls="print-menu"
                aria-haspopup="true"
                onClick={(event) => setAnchorElOptions(event.currentTarget)}
                color="inherit"
            >
                <MoreHoriz />
            </IconButton>
            <Menu
                id="print-menu"
                anchorEl={anchorElOptions}
                open={Boolean(anchorElOptions)}
                onClose={() => setAnchorElOptions(null)}
            >
                <MenuItem onClick={() => window.open("/#/inscricao?uid=" + inscricao.uid, "_blank")}>Editar</MenuItem>
                <MenuItem onClick={(event) => setAnchorElStatus(event.currentTarget)}>Alterar Status Evento</MenuItem>
                <MenuItem onClick={() => window.open("/#/painel-inscrito?uid=" + inscricao.uid, '_blank')}>
                    Abrir painel do inscrito
                </MenuItem>
            </Menu>
            <Menu
                id="status-submenu"
                anchorEl={anchorElStatus}
                open={Boolean(anchorElStatus)}
                onClose={() => setAnchorElStatus(null)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                getContentAnchorEl={null}
            >
                <MenuItem onClick={inscritoOnClick}>INSCRITO</MenuItem>
                <MenuItem onClick={() => setOpenAusente(true)}>AUSENTE</MenuItem>
            </Menu>

            <DialogStatus
                open={openAusente}
                setOpen={setOpenAusente}
                statusLabel={"AUSENTE"}
                statusCb={ausenteOnClick}
            />
            <DialogStatus open={openSaiu} setOpen={setOpenSaiu} statusLabel={"SAIU"} statusCb={saiuOnClick} />
            {/* <DialogStatus open={openAusente} setOpen={setOpenAusente} statusLabel={"AUSENTE"} statusCb={ausenteOnClick} /> */}
        </Box>
    );
}
